import React, { PropTypes } from 'react';
import { Link, withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import cn from 'classnames';

import './MaterialTypeLink.scss';

export class MaterialTypeLink extends BcReactComponent {
  getLinkURL() {
    const { router, materialType } = this.props;
    return {
      pathname: router.location.pathname,
      query: {
        ...router.location.query,
        materialType,
        page: 1
      }
    };
  }

  render() {
    const { count, router, materialType } = this.props;
    const currentMaterialType = router.location.query.materialType;
    const classnames = cn('cp-material-type-link', {
      active: materialType === currentMaterialType || (!materialType && !currentMaterialType)
    });
    return (
      <Link className={classnames} to={this.getLinkURL()}>
        <FormattedMessage
          id={`filter_material_type_${(materialType || 'all').toLowerCase()}`}
          values={{ count }} />
      </Link>
    );
  }
}

MaterialTypeLink.PropTypes = {
  count: PropTypes.number,
  materialType: PropTypes.string
};


export default withRouter(MaterialTypeLink);



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/MaterialTypeLink/MaterialTypeLink.jsx